import { APP_NAME, WLAC_CONTAINER_ID } from '@shared-utils/types/common.types';
export const ON_ANALYTICS = 'onAnalytics';
const emit = (eventName, params, logger, parentId = WLAC_CONTAINER_ID) => {
    const agencyCardComponent = document.getElementById(parentId);
    const event = new CustomEvent(`${APP_NAME}:${eventName}`, { detail: params });
    if (agencyCardComponent) {
        agencyCardComponent.dispatchEvent(event);
    }
    else {
        logger(`EventBus: ${APP_NAME} container not found`, {
            eventName,
            params,
        });
    }
};
export const EventBus = { emit };
